function BlogEditorPage() {
  return (
    <div>
      <h2>Blog Editor (Netlify CMS handles this via /admin)</h2>
    </div>
  );
}

export default BlogEditorPage;
